import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import ruRU from 'antd/lib/locale/ru_RU';

import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';

import 'antd/dist/reset.css';
import './style.scss';

ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider locale={ruRU}>
            <Router>
                <App />
            </Router>
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
);

serviceWorker.unregister();
